import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {
  getFiltersForGroups,
} from '../actions/communication';
import GroupMessages from '../components/communication/GroupMessages';
import IndividualMessages from '../components/communication/IndividualMessages';
import SendingAs from '../components/communication/SendingAs';
import SubNavBar from '../containers/nav/SubNavBar';
import TopNavBar from '../containers/nav/TopNavBar';

const CommunicationPage = ({
  auth,
  getFiltersForGroups,
}) => {
  useEffect(() => {
    getFiltersForGroups();
  }, []);

  return (
    <DocumentTitle title="Messaging">
      <div className="page-container o-communication">
        <TopNavBar auth={auth}/>
        <SubNavBar/>

        <div className="container-fluid o-communication__container">
          <SendingAs/>
          <Tabs className="row u-margin-top--zero o-communication__container--main-full">
            <TabList>
              <Tab>Individuals</Tab>
              <Tab>Groups</Tab>
            </TabList>
            <TabPanel>
              <IndividualMessages/>
            </TabPanel>
            <TabPanel>
              <GroupMessages/>
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </DocumentTitle>
  )
}

CommunicationPage.propTypes = {
  auth: PropTypes.object.isRequired,
  getFiltersForGroups: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getFiltersForGroups,
})(CommunicationPage);
